import { Box } from '@wix/design-system';
import React from 'react';
export const ProductCardFeatureList = ({ features, renderRow, className, dataHook, ...props }) => {
    return (React.createElement(Box, { width: "100%", ...props, direction: "vertical", align: "left", className: className, dataHook: dataHook }, features.map((c, idx) => renderRow(c, idx))));
};
//# sourceMappingURL=ProductCardFeatureList.js.map